<script setup lang="ts">
const { disabled = false, focussed = false } = defineProps<{
  disabled?: boolean;
  focussed?: boolean;
}>();

const classObject = computed(() => ({
  ["is-disabled"]: disabled,
  ["is-focussed"]: focussed,
}));
</script>

<template>
  <div class="chat-send-button" :class="classObject">
    <BaseIcon name="send" class="send" :class="{ 'is-disabled': disabled }" />
  </div>
</template>

<style lang="scss" scoped>
.chat-send-button {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 3rem;
  height: 3rem;
  box-sizing: border-box;
  border: solid 2px var(--chat-input-border-color);

  border-left-width: 0;
  border-radius: 0 var(--main-border-radius) var(--main-border-radius) 0;
  background-color: var(--chat-input-background-color);
  background-image: linear-gradient(
    to right,
    var(--chat-input-border-color) 50%,
    var(--chat-input-background-color) 50%
  );
  background-size: 200% 100%;
  color: var(--chat-input-background-color);
  font-size: 1.8rem;
  overflow: hidden;
  transition:
    all 200ms ease,
    border-color 100ms ease;
  cursor: pointer;

  &.is-disabled {
    background-color: var(--chat-input-focus-color);
    background-position: -100% 0;
    color: var(--chat-input-text-color);
    pointer-events: none;
  }

  &.is-focussed {
    border-color: var(--chat-input-focus-color);
    background-image: linear-gradient(
      to right,
      var(--chat-input-focus-color) 50%,
      var(--chat-input-background-color) 50%
    );
  }
}
</style>
